import { Mui } from "@osu/react-ui";

const Paper = Mui.styled(Mui.Paper)(({ theme }) => {
  return {
    padding: theme.spacing(3),
    width: '100%',
    height: '100%',
  };
});

export default Paper;
